import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section"><inlineCode parentName="p">{`localeProjection`}</inlineCode>{` - String - Optional`}<br parentName="p"></br>{`
`}<a parentName="p" {...{
          "href": "https://en.wikipedia.org/wiki/IETF_language_tag"
        }}>{`IETF language tag`}</a>{`.`}<br parentName="p"></br>{`
`}{`Enables `}<a parentName="p" {...{
          "href": "/api/../api/projects/productProjections#locales"
        }}>{`locale based projection`}</a>{`.`}<br parentName="p"></br>{`
`}{`To set more than one locale, use this query parameter multiple times.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      